// WEXHUB: override en runtime del bundle de i18n para renombrar "Agente(s)" a "Operador(s)"
// en el locale es, sin editar ninguno de los JSON de locale (archivos upstream del fork).
import dashboardI18n from 'dashboard/i18n';

const AGENTE_REGEX = /\bAgentes\b|\bAgente\b|\bagentes\b|\bagente\b/g;

const AGENTE_REPLACEMENTS = {
  Agentes: 'Operadores',
  Agente: 'Operador',
  agentes: 'operadores',
  agente: 'operador',
};

const replaceAgente = match => AGENTE_REPLACEMENTS[match] ?? match;

const transformValue = value => {
  if (typeof value === 'string') {
    return value.replace(AGENTE_REGEX, replaceAgente);
  }
  if (Array.isArray(value)) {
    return value.map(transformValue);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, transformValue(val)])
    );
  }
  return value;
};

export default {
  ...dashboardI18n,
  es: transformValue(dashboardI18n.es),
};
